import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} ${movie.genre} ${movie.year} - 97影院`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 top-2 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-bold text-primary-950">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-medium text-background-50">
          {movie.category === "tv" ? "剧集" : "电影"}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 md:text-base">{movie.title}</h3>
        <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
          <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">{movie.genre}</span>
          <span>{movie.year}</span>
          <span className="truncate">{movie.region}</span>
        </div>
      </div>
    </Link>
  );
}